import { useEffect, useState } from 'react';
import { ucumUtils } from 'my-phr/utils/conversion';
import usePhrUnitValuePreference from './usePhrUnitValuePreference';

export const DISTANCE_UNITS_CODES = {
  FEET: '[ft_i]',
  MILES: '[mi_i]',
  METERS: 'm',
  KILOMETERS: 'km',
};

export const DISTANCE_UNITS = {
  FEET: 'ft',
  MILES: 'mi',
  METERS: 'm',
  KILOMETERS: 'km',
};

export default function useConvertDistanceData(data) {
  const { getUnit, getValue } = usePhrUnitValuePreference();
  const preferenceUnit = getUnit(data);
  const preferenceValue = getValue(data);

  const [convertedValue, setConvertedValue] = useState({
    value: preferenceValue,
    unit: preferenceUnit,
  });

  useEffect(() => {
    if (preferenceUnit === DISTANCE_UNITS.FEET) {
      const conversionResultToMiles = ucumUtils.convertUnitTo(
        DISTANCE_UNITS_CODES.FEET,
        preferenceValue,
        DISTANCE_UNITS_CODES.MILES
      );
      setConvertedValue({
        value: conversionResultToMiles.toVal,
        unit: conversionResultToMiles?.toUnit?.printSymbol_,
      });
    } else if (preferenceUnit === DISTANCE_UNITS.METERS) {
      const conversionResultToKilometers = ucumUtils.convertUnitTo(
        DISTANCE_UNITS_CODES.METERS,
        preferenceValue,
        DISTANCE_UNITS_CODES.KILOMETERS
      );
      setConvertedValue({
        value: conversionResultToKilometers.toVal,
        unit: conversionResultToKilometers?.toUnit?.printSymbol_,
      });
    } else {
      setConvertedValue({ value: preferenceValue, unit: preferenceUnit });
    }
  }, [preferenceUnit, preferenceValue]);

  return { convertedValue };
}
